module.exports = __webpack_public_path__ + "images/post_placeholder.png";


//////////////////
// WEBPACK FOOTER
// ./images/post_placeholder.png
// module id = 180
// module chunks = 0